import { nullableNumber, requiredIntegerMoreThanZero, requiredString } from "common";
import { EquipmentAllocationStrategy, GuidePreference, PrioritizedResourceID } from "types";
import { bool, object, string } from "yup";

export const ExperienceResourceValidationSchema = object().shape({
    guidePreference: object().shape({
        includeGuideInfo: bool(),
        referGuideAs: string().when("includeGuideInfo", {
            is: true,
            then: requiredString(),
        }),
        guideNotAssigned: object(),
    }),
    earlyReturn: bool().required(),
    allowCheckoutAtArrival: bool(),
    duration: requiredIntegerMoreThanZero(),
    eventDuration: nullableNumber(),
});

export interface ExperienceResourceSettingValues {
    guidePreference?: GuidePreference;
    duration: number;
    eventDuration?: number;
    earlyReturn: boolean;
    allowCheckoutAtArrival?: boolean;
    inventory?: {
        allocationStrategy: EquipmentAllocationStrategy;
        prioritizedResources?: PrioritizedResourceID[];
    };
}
